import { render, staticRenderFns } from "./reset-password-bb.vue?vue&type=template&id=486c7dc0&scoped=true"
import script from "./reset-password-bb.vue?vue&type=script&lang=js"
export * from "./reset-password-bb.vue?vue&type=script&lang=js"
import style0 from "./reset-password-bb.vue?vue&type=style&index=0&id=486c7dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c7dc0",
  null
  
)

export default component.exports